import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import {
  useFullscreenContext,
  withFullscreenContext,
} from '../../../utils/contexts/FullscreenContext';
import { FullscreenContainer } from '../../FullscreenContainer/FullscreenContainer';
import { IStyled } from '../../../styles/types';

interface IProps extends IStyled {
  imageUrl: string;
  onClick?: () => void;
}

const ImagePreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
const ImagePreview = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  user-select: none;
`;
const ImageThumbnail = styled.img`
  display: block;
  margin-top: 4px;
  width: 100%;
  max-height: 183px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid ${theme.colors.secondary300};
  &:hover {
    cursor: pointer;
    border-color: ${theme.colors.mainBlue};
  }
`;

const CommentImageEmbed = ({ imageUrl, onClick, className }: IProps) => {
  const { isFullScreen, toggleFullScreen } = useFullscreenContext();

  // Clicking on thumbnail will open an image preview in fullscreen modal
  const handleThumbnailClick = () => {
    if (onClick) {
      onClick();
    }
    toggleFullScreen();
  };

  if (isFullScreen) {
    return (
      <FullscreenContainer>
        <ImagePreviewContainer>
          <ImagePreview src={imageUrl} alt="uploaded image" />
        </ImagePreviewContainer>
      </FullscreenContainer>
    );
  }

  return (
    <ImageThumbnail
      src={imageUrl}
      alt="uploaded image"
      onClick={handleThumbnailClick}
      className={className}
    />
  );
};

export default withFullscreenContext(CommentImageEmbed);
